import type { ReactNode } from "react";
import { COMPANY_SHORT_NAME, COMPANY_URL } from "../lib/brand";

// "Nebulon Labs", linked to the company's own site, wherever a page says the
// product is a Nebulon Labs product.
export default function CompanyLink() {
  return (
    <a href={COMPANY_URL} target="_blank" rel="noopener" className="font-medium underline-offset-2 hover:underline">
      {COMPANY_SHORT_NAME}
    </a>
  );
}

// A sentence with the company's name in it, the name linked. For copy that
// lives as plain strings (lib/marketing.ts).
export function withCompanyLink(text: string): ReactNode {
  const parts = text.split(COMPANY_SHORT_NAME);
  if (parts.length === 1) return text;
  return parts.flatMap((part, index) => (index === 0 ? [part] : [<CompanyLink key={index} />, part]));
}
